export const QUERY_STALE_TIMES = {
	REALTIME: 0, // menu items, stock, pricing — never serve stale
	SHORT: 30 * 1000, // location hours
	MEDIUM: 2 * 60 * 1000, // loyalty config
	LONG: 10 * 60 * 1000, // static reference data
} as const

export const QUERY_KEYS = {
	customerProfile: ['customer-profile'],
	customerPaymentMethods: ['customer-payment-methods'],
} as const
